export default __webpack_public_path__ + "images/bfeb51cb8f87abda41e3286c06357786-swimmingandwatersports_small.webp";